var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-icon btn-circle btn-success btn-scroll-to-top fade",class:{ 'show': _vm.appOptions.appBodyScrollTop },on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"fa fa-angle-up"})])])}
var staticRenderFns = []

export { render, staticRenderFns }